import React from 'react';
import locales from '../../../../../content.json';
import { useDigitalProductPrice } from '../../../pdfUpselling/components/price/useDigitalProductPrice';
import s from './index.module.scss';

export const PriceK9 = () => {
  const { price, oldPrice, currency } = useDigitalProductPrice({ k9Guide: true });

  return (
    <div className={s.wrapper}>
      <div className={`${s.row} ${currency === 'USD ' ? s.USD : ''}`}>
        <p className={s.label}>{locales[window.userLang].pdfUpselling_13}</p>
        <div className={s.values}>
          <p className={s.discount}>-54%</p>
          <p className={s.oldPrice}>{currency}{oldPrice}</p>
          <p className={s.totalPrice}>{currency}{price}</p>
        </div>
      </div>
    </div>
  );
};
